import portalClient from "./clients/portalClient";
import calculationClient from "./clients/calculationClient";
import projectFormClient from "./clients/projectFormClient";

const getAllOffers = () => portalClient.get(`/sales_offers`);
const getOffer = (id) => portalClient.get(`/sales_offers/${id}`);
const postOffer = (data) => portalClient.post(`/sales_offers`, data);
const addContactToOffer = (id, data) => portalClient.post(`/sales_offers/${id}/accounts`, data);

const getHistory = (id) => portalClient.get(`/sales_offers/${id}/history`);

const getMessages = (id) => portalClient.get(`/sales_offers/${id}/messages`);
const deleteMessage = (id, sId) => portalClient.delete(`/sales_offers/${id}/messages/${sId}`);
const postMessage = (id, data) => portalClient.post(`/sales_offers/${id}/messages`, data);

const getTasks = (id) => portalClient.get(`/sales_offers/${id}/tasks`);
const postTask = (id, data) => portalClient.post(`/sales_offers/${id}/tasks`, data);
const editTask = (id, sId, data) => portalClient.put(`/sales_offers/${id}/tasks/${sId}`, data);
const deleteTask = (id, sId) => portalClient.delete(`/sales_offers/${id}/tasks/${sId}`);

const postNewOffer = (data) => portalClient.post(`/sales_offers`, data);
const editExistingOffer = (id, data) => portalClient.put(`/sales_offers/${id}`, data);
const editExistingOfferStatus = (id, data) => portalClient.put(`/sales_offers/${id}/status?status=${data}`);
const editOfferFinance = (id, data) => portalClient.put(`/sales_offers/${id}/finance`, data);

const deleteOffer = (id) => portalClient.delete(`/sales_offers/${id}`);


const getAccounts = (id) => portalClient.get(`/sales_offers/${id}/accounts`);
const postAccount = (id, data) => portalClient.post(`/sales_offers/${id}/accounts`, data);
const editAccount = (id, data) => portalClient.put(`/sales_offers/${id}/accounts`, data);
const deleteAccount = (id) => portalClient.delete(`/sales_offers/${id}/accounts`);

const getCalculations = (id) => calculationClient.get(`/get/calculations/${id}`);
const createNewCalculation = (data) => calculationClient.post(`/crud/calculation/new`, data);
const deleteCalculation = (data) => calculationClient.post(`/crud/calculation/delete`, {id: data});
const copyCalculation = (data) => calculationClient.post(`/crud/calculation/duplicate`, data);

const getAllForms = (id) => projectFormClient.get(`/project/${id}/forms`);
const getForm = (id) => projectFormClient.get(`/forms/${id}`);
const createNewForm = (data) => projectFormClient.post(`/forms`, data);
const deleteForm = (id) => projectFormClient.delete(`/forms/${id}`);

const getAllService = (id) => projectFormClient.get(`/service/${id}/forms`);
const getService = (id) => projectFormClient.get(`/service/${id}`);
const createNewService = (data) => projectFormClient.post(`/service`, data);
const deleteService = (id) => projectFormClient.delete(`/service/${id}`);


const offersApi = {
    getAllOffers,
    getOffer,
    postOffer,
    addContactToOffer,

    getHistory,

    getMessages,
    deleteMessage,
    postMessage,

    getTasks,
    postTask,
    editTask,
    deleteTask,


    postNewOffer,
    editExistingOffer,
    editExistingOfferStatus,
    editOfferFinance,
    deleteOffer,

    getAccounts,
    postAccount,
    editAccount,
    deleteAccount,

    getCalculations,
    createNewCalculation,
    deleteCalculation,
    copyCalculation,

    getAllForms,
    getForm,
    createNewForm,
    deleteForm,
    
    getAllService,
    getService,
    createNewService,
    deleteService,
};

export default offersApi;
